module.exports = __webpack_public_path__ + "static/index/img/baikal-600.2516b110.jpg";